/**
 * Simple error logging utility
 * Logs to console in dev
 */

/**
 * Log an error with context
 * @param error - The error to log
 * @param context - Where the error occurred (e.g., 'auth:logout', 'api:applications')
 */
export function logError(error: unknown, context: string): void {
  const timestamp = new Date().toISOString();
  const errorMessage = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  console.error(`[${timestamp}] [${context}]`, errorMessage, {
    error,
    stack,
  });
}
